import { createTV } from 'tailwind-variants';

/* All ComplyKit utilities are ck-prefixed (see generate-theme.ts); without
 * the matching prefix config, tailwind-merge would treat `ck:` as an unknown
 * variant and could drop or keep the wrong class when callers override.
 * The surface utilities paint a background, so a later surface or bg class
 * replaces an earlier one the way two bg classes replace each other;
 * otherwise both stay and the stylesheet's order picks the winner. */
export const tv = createTV({
  twMergeConfig: {
    prefix: 'ck',
    extend: {
      classGroups: { surface: [{ surface: ['recessed', 'base', 'raised', 'overlay'] }] },
      conflictingClassGroups: { surface: ['bg-color'], 'bg-color': ['surface'] },
    },
  },
});
